import ManagerPinDialog from '@/components/common/ManagerPinDialog.vue'

export default {
  components: {
    ManagerPinDialog
  },

  mixins: [],

  data() {
    return {
      confirmManagerPinDialogVisible: false,
      managerPinDialogData          : null
    }
  },

  created() {
    this.$bus.$on('show-manager-pin-dialog', this.showManagerPinDialog)
    this.$bus.$on('hide-manager-pin-dialog', this.hideManagerPinDialog)
  },

  beforeDestroy() {
    this.$bus.$off('show-manager-pin-dialog', this.showManagerPinDialog)
    this.$bus.$off('hide-manager-pin-dialog', this.hideManagerPinDialog)
  },

  methods: {
    showManagerPinDialog(data) {
      this.managerPinDialogData = data
      this.confirmManagerPinDialogVisible = true
    },

    hideManagerPinDialog() {
      this.confirmManagerPinDialogVisible = false
    }
  }
}
